// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"990045ef","453":"831fdb67","455":"6a3474d3"}[chunkId] + ".chunk.js";
};